import script from "./contentsDetailPage.vue?vue&type=script&setup=true&lang=js"
export * from "./contentsDetailPage.vue?vue&type=script&setup=true&lang=js"

import "./contentsDetailPage.vue?vue&type=style&index=0&id=3a13f573&scoped=true&lang=css"

import exportComponent from "F:\\workspace\\eduwind-front\\eduwind-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a13f573"]])

export default __exports__